import { createContext } from 'react';

export const BloodlineContext = createContext<number | null>(null);
